var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-button',{staticClass:"create-synchronization-button",attrs:{"type":"primary"},on:{"click":_setup.goToCreateSynchronization}},[_c('a-icon',{attrs:{"type":"plus"}}),_vm._v(" "+_vm._s(_vm.$t("synchronization.create_synchronization"))+" ")],1),_c(_setup.SyncListTable)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }